export const SUPPORT_WHATSAPP_E164 = '+5511934297757'
